import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=2f1a6762&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=2f1a6762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a6762",
  null
  
)

component.options.__file = "HeaderTitle.vue"
export default component.exports